import { render, staticRenderFns } from "./AssignmentFilter.vue?vue&type=template&id=3db08980&scoped=true"
import script from "./AssignmentFilter.vue?vue&type=script&lang=js"
export * from "./AssignmentFilter.vue?vue&type=script&lang=js"
import style0 from "./AssignmentFilter.vue?vue&type=style&index=0&id=3db08980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db08980",
  null
  
)

export default component.exports